import {  UPI_BANK_SUCCESS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Upi_Bank_Success = (payload) => {
  return apiInstance.post(UPI_BANK_SUCCESS, payload);
};
